<template>
  <VSection label="autotopupregistrations.deregistration_headline">
    <VDescriptionListDividedHorizontal>
      <VEntryDate :data="registrationDetails" field="deletionDatetime" name="autotopupregistrations.registration_deletion_datetime_label" />
      <VEntry
        :value="$to(`autotopupregistrations.registration_deleted_by_${registrationDetails.deletedBy}`)"
        name="autotopupregistrations.registration_deleted_by_label"
        mandatory
      />
      <VEntry :data="registrationDetails" field="deregistrationReasonCode" name="autotopupregistrations.registration_deletion_reason_code_label" />
      <VEntry :data="registrationDetails" field="deregistrationReason" name="autotopupregistrations.registration_deletion_reason_label" />
      <VEntry
        v-if="showReasonTranslation"
        :value="$to(`autotopupregistrations.registration_deletion_translated_reason_${registrationDetails.deregistrationReasonCode}`)"
        name="autotopupregistrations.registration_deletion_translated_reason_code_label"
      />
    </VDescriptionListDividedHorizontal>
  </VSection>
</template>

<script>
import VSection from '@/components/Section';
import VDescriptionListDividedHorizontal from '@/components/DescriptionList/DividedHorizontal';
import VEntry from '@/components/DescriptionList/Entry';
import VEntryDate from '@/components/DescriptionList/EntryDate';

export default {
  name: 'AutoTopUpRegistrationDetailsDeregistration',

  components: {
    VSection,
    VDescriptionListDividedHorizontal,
    VEntry,
    VEntryDate,
  },

  props: {
    registrationDetails: {
      type: Object,
      required: true,
    },
  },
  computed: {
    showReasonTranslation() {
      return (
        this.registrationDetails.deregistrationReasonCode &&
        this.$te(`autotopupregistrations.registration_deletion_translated_reason_${this.registrationDetails.deregistrationReasonCode}`)
      );
    },
  },
};
</script>
